import { render, staticRenderFns } from "./BrokerAlert.vue?vue&type=template&id=db00293c&"
import script from "./BrokerAlert.vue?vue&type=script&lang=js&"
export * from "./BrokerAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports